import { NgModule, Injectable } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxUploaderModule } from 'ngx-uploader';
import { FileUploadModule } from 'ng2-file-upload/ng2-file-upload';
import { HttpClientModule } from '@angular/common/http';
import { QuestionarieSignupRoutingModule } from './questionarie-signup-routing.module';
import { QuestionarieSignupComponent } from './questionarie-signup.component';
import { SignupComponent } from './signup/signup.component';
import { RecaptchaModule } from 'ng-recaptcha';
import { ModalModule, TypeaheadModule, CollapseModule } from 'ngx-bootstrap';

import { AgmCoreModule } from '@agm/core';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';

import { SkippageComponent } from './skippage/skippage.component';
import { SignupOptionsComponent } from './signup-options/signup-options.component';
import { QuestionnaireResidentialComponent } from './questionnaire-residential/questionnaire-residential.component';
import { ResidentialQuestionComponent } from './questionnaire-residential/residential-question/residential-question.component';
import { RQ1Component } from './questionnaire-residential/residential-question/r-q1/r-q1.component';
import { RQ2Component } from './questionnaire-residential/residential-question/r-q2/r-q2.component';
import { RQ3Component } from './questionnaire-residential/residential-question/r-q3/r-q3.component';
import { RQ4Component } from './questionnaire-residential/residential-question/r-q4/r-q4.component';
import { ResidentialDirective } from './questionnaire-residential/residential.directive';
import { RQ5Component } from './questionnaire-residential/residential-question/r-q5/r-q5.component';
import { RQ6Component } from './questionnaire-residential/residential-question/r-q6/r-q6.component';
import { RQ7Component } from './questionnaire-residential/residential-question/r-q7/r-q7.component';
import { RQ8Component } from './questionnaire-residential/residential-question/r-q8/r-q8.component';
import { RQ9Component } from './questionnaire-residential/residential-question/r-q9/r-q9.component';
import { RQ10Component } from './questionnaire-residential/residential-question/r-q10/r-q10.component';
import { RQ11Component } from './questionnaire-residential/residential-question/r-q11/r-q11.component';
import { RQ12Component } from './questionnaire-residential/residential-question/r-q12/r-q12.component';
import { RQ13Component } from './questionnaire-residential/residential-question/r-q13/r-q13.component';
import { RQ14Component } from './questionnaire-residential/residential-question/r-q14/r-q14.component';
import { RQ15Component } from './questionnaire-residential/residential-question/r-q15/r-q15.component';
import { RQ16Component } from './questionnaire-residential/residential-question/r-q16/r-q16.component';
import { RQ17Component } from './questionnaire-residential/residential-question/r-q17/r-q17.component';
import { RQ18Component } from './questionnaire-residential/residential-question/r-q18/r-q18.component';
import { RQ19Component } from './questionnaire-residential/residential-question/r-q19/r-q19.component';
import { RQ20Component } from './questionnaire-residential/residential-question/r-q20/r-q20.component';
import { RQ21Component } from './questionnaire-residential/residential-question/r-q21/r-q21.component';
import { RQ22Component } from './questionnaire-residential/residential-question/r-q22/r-q22.component';
import { RQ23Component } from './questionnaire-residential/residential-question/r-q23/r-q23.component';
import { RQ24Component } from './questionnaire-residential/residential-question/r-q24/r-q24.component';
import { RQ25Component } from './questionnaire-residential/residential-question/r-q25/r-q25.component';
import { RQ26Component } from './questionnaire-residential/residential-question/r-q26/r-q26.component';
import { RQ27Component } from './questionnaire-residential/residential-question/r-q27/r-q27.component';
import { RQ28Component } from './questionnaire-residential/residential-question/r-q28/r-q28.component';
import { RQ29Component } from './questionnaire-residential/residential-question/r-q29/r-q29.component';
import { RQ30Component } from './questionnaire-residential/residential-question/r-q30/r-q30.component';
import { RQ31Component } from './questionnaire-residential/residential-question/r-q31/r-q31.component';
import { SuccessComponent } from './questionnaire-residential/success/success.component';
import { PreSuccessComponent } from './questionnaire-residential/pre-success/pre-success.component';
import { RecommendationComponent } from './questionnaire-residential/recommendation/recommendation.component';
import { ChartModule } from 'angular-highcharts';
import { InitialOptionsComponent } from './questionnaire-residential/recommendation/initial-options/initial-options.component';
import { SingleProductComponent } from './questionnaire-residential/recommendation/single-product/single-product.component';
import { CompareProductComponent } from './questionnaire-residential/recommendation/compare-product/compare-product.component';
import { HighchartsChartModule } from 'highcharts-angular';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonHeaderModule } from '../common-header/common-header.module';
import { HgCommonModule } from '../hg-common/hg-common.module';
import { HomeMainModule } from '../home-main/home-main.module';
import { MyDatePickerModule } from 'mydatepicker';
import { FourDigitDecimaNumberDirective } from './questionnaire-residential/four-decimal.directive';
import { SignupOrderComponent } from './questionnaire-residential/signup-order/signup-order.component';
import { PreCongratsComponent } from './questionnaire-residential/pre-congrats/pre-congrats.component';
import { ServiceTypeComponent } from './questionnaire-residential/signup-order/service-type/service-type.component';
import { EnrollmentComponent } from './questionnaire-residential/signup-order/enrollment/enrollment.component';
import { MaskPipe } from './questionnaire-residential/signup-order/enrollment/mask.pipe';
import { CongratsComponent } from './questionnaire-residential/congrats/congrats.component';
import { EnergyplanConfirmationComponent } from './questionnaire-residential/energyplan-confirmation/energyplan-confirmation.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ShareButtonModule, ShareButtonComponent } from 'ngx-sharebuttons';
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';
import { SpecialCharacterDirective } from './questionnaire-residential/specialCharacter.directive';
import { NumberDirective } from './questionnaire-residential/numbers-only.directive';
import { AlphaNumericDirective } from './questionnaire-residential/alphaNumeric.directive';
import { AlphaNumericHyphenDirective } from './questionnaire-residential/alphaNumeric.directive';
import { NgSelectModule } from '@ng-select/ng-select';
import { DebounceClickDirective } from './questionnaire-residential/debounce-click.directive';
import { SsnCheckComponent } from './questionnaire-residential/signup-order/ssn-check/ssn-check.component';
import { SSnopenwithdepositComponent } from './questionnaire-residential/signup-order/ssn-check/ssn-openwithdeposit.component';
import { DepositRequiredComponent } from './questionnaire-residential/signup-order/ssn-check/depositrequired.component';
import { CreditCheckFurutherActionComponent } from './questionnaire-residential/signup-order/ssn-check/creditcheck-furtheraction.component';
import { ServiceDeniedComponent } from './questionnaire-residential/signup-order/ssn-check/service-denied.component';
import { ThankyouComponent } from './questionnaire-residential/signup-order/ssn-check/thankyou.component';
import {
  HammerGestureConfig,
  HAMMER_GESTURE_CONFIG,
} from '@angular/platform-browser';
import { PhoneNumberDirective } from './phone-number.directive';
import { PrepaidConfirmationComponent } from './questionnaire-residential/pre-paid-success/prepaid-confirmation.component';
import { StatusLoading } from './questionnaire-residential/status-loading/status-loading.component';
import { DepositRequired4CEComponent } from './questionnaire-residential/signup-order/ssn-check/depositrequired4CE.component';
import { DepositRequiredBKVComponent } from './questionnaire-residential/signup-order/ssn-check/depositrequiredBKV.component';
import { DatepickerComponent } from './datepicker/datepicker.component';
import { MaterialModule } from '../material-module';
import { ProductComparisonComponent } from './questionnaire-residential/recommendation/product-comparison/product-comparison.component';
// import { PlanSummaryComponent } from './questionnaire-residential/signup-order/plan-summary/plan-summary.component';
// import { SnackbarComponent } from '../snackbar/snackbar.component';
@Injectable()
export class CustomHammerConfig extends HammerGestureConfig {
  overrides = <any>{
    pan: {
      direction: 6,
    },
    pinch: {
      enable: false,
    },
    rotate: {
      enable: false,
    },
  };
}

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    NgxUploaderModule,
    FileUploadModule,
    ReactiveFormsModule,
    HttpClientModule,
    QuestionarieSignupRoutingModule,
    RecaptchaModule.forRoot(),
    ChartModule,
    HighchartsChartModule,
    CommonHeaderModule,
    HgCommonModule,
    HomeMainModule,
    BrowserAnimationsModule,
    MyDatePickerModule,
    GooglePlaceModule,
    NgxSpinnerModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyDGLXj7CWMeCf-OcQFz3lUTglkuDDYg_6c',
      libraries: ['places'],
    }),
    ModalModule.forRoot(),
    TypeaheadModule.forRoot(),
    ShareButtonModule.forRoot(),
    ScrollToModule.forRoot(),
    NgSelectModule,
    CollapseModule.forRoot(),
  ],
  providers: [
    {
      provide: HAMMER_GESTURE_CONFIG,
      useClass: CustomHammerConfig,
    },
  ],
  declarations: [
    QuestionarieSignupComponent,
    SignupComponent,
    SkippageComponent,
    SignupOptionsComponent,
    QuestionnaireResidentialComponent,
    ResidentialQuestionComponent,
    RQ1Component,
    RQ2Component,
    RQ3Component,
    RQ4Component,
    ResidentialDirective,
    RQ5Component,
    RQ6Component,
    RQ7Component,
    RQ8Component,
    RQ9Component,
    RQ10Component,
    RQ11Component,
    RQ12Component,
    RQ13Component,
    RQ14Component,
    RQ15Component,
    RQ16Component,
    RQ17Component,
    RQ18Component,
    RQ19Component,
    RQ20Component,
    RQ21Component,
    RQ22Component,
    RQ23Component,
    RQ24Component,
    RQ25Component,
    RQ26Component,
    RQ27Component,
    RQ28Component,
    RQ29Component,
    RQ30Component,
    RQ31Component,
    SuccessComponent,
    PreSuccessComponent,
    RecommendationComponent,
    InitialOptionsComponent,
    SingleProductComponent,
    CompareProductComponent,
    FourDigitDecimaNumberDirective,
    PhoneNumberDirective,
    SignupOrderComponent,
    PreCongratsComponent,
    ServiceTypeComponent,
    EnrollmentComponent,
    MaskPipe,
    CongratsComponent,
    EnergyplanConfirmationComponent,
    SpecialCharacterDirective,
    NumberDirective,
    AlphaNumericDirective,
    AlphaNumericHyphenDirective,
    DebounceClickDirective,
    SsnCheckComponent,
    SSnopenwithdepositComponent,
    DepositRequiredComponent,
    CreditCheckFurutherActionComponent,
    ServiceDeniedComponent,
    ThankyouComponent,
    PrepaidConfirmationComponent,
    StatusLoading,
    DepositRequired4CEComponent,
    DepositRequiredBKVComponent,
    DatepickerComponent,
    ProductComparisonComponent,
    // PlanSummaryComponent,
    // SnackbarComponent,
  ],
  entryComponents: [
    RQ1Component,
    RQ2Component,
    RQ3Component,
    RQ4Component,
    RQ5Component,
    RQ6Component,
    RQ7Component,
    RQ8Component,
    RQ9Component,
    RQ10Component,
    RQ11Component,
    RQ12Component,
    RQ13Component,
    RQ14Component,
    RQ15Component,
    RQ16Component,
    RQ17Component,
    RQ18Component,
    RQ19Component,
    RQ20Component,
    RQ21Component,
    RQ22Component,
    RQ23Component,
    RQ24Component,
    RQ25Component,
    RQ26Component,
    RQ27Component,
    RQ28Component,
    RQ29Component,
    RQ30Component,
    RQ31Component,
    PreSuccessComponent,
    SuccessComponent,
    RecommendationComponent,
    InitialOptionsComponent,
    SingleProductComponent,
    CompareProductComponent,
    // SnackbarComponent,
  ],
})
export class QuestionarieSignupModule {}
